import {
  storeDefault,
  storeRequest,
  storeFilled,
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
} from 'js/helpers/reducers';

import { formatReportWithMap } from 'js/helpers/ReportUtils.js';

import {
  FETCH_REPORT,
  FETCHED_REPORT,
  FETCH_REPORTS_LIST,
  FETCHED_REPORTS_LIST,
  SET_REPORTS_LIST_FILTER,
} from 'components/Pages/Reports/actions.js';

const defaultState = {
  reportsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 40,
    sortBy: 'created_at',
    sortOrder: 'desc',
  }),
  report: storeDefault({}),
};

// eslint-disable-next-line complexity
const EntityProfileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case FETCH_REPORTS_LIST:
      return ListRequestHandler(state, action, 'reportsList');
    case FETCHED_REPORTS_LIST:
      return ListSuccessHandler(state, action, 'reportsList');
    case SET_REPORTS_LIST_FILTER:
      return ListFilterHandler(state, action, 'reportsList');
    case FETCH_REPORT:
      return Object.assign({}, state, { report: storeRequest({}) });
    case FETCHED_REPORT: {
      return Object.assign({}, state, { report: storeFilled(formatReportWithMap(action)) });
    }
    default:
      return Object.assign({}, state);
  }
};

export default EntityProfileReducer;
